import $ from 'jquery';

class SiteCarousel {

  constructor(carouselEl) {

    this.$el = $(carouselEl);

    var $manySlideCarousel = this.$el.find('.site-carousel__carousel--many-slides');
    var $automaticCarousel = this.$el.find('.site-carousel__carousel--automatic');
    // var $prevArrowEl = this.$el.find('.site-carousel__prev-btn')
    // var $nextArrowEl = this.$el.find('.site-carousel__next-btn')
    var $prevArrowEl = this.$el.find('.js-prev')
    var $nextArrowEl = this.$el.find('.js-next')

    if ($manySlideCarousel.length > 0) {
      // Site wide carousel
      this.$carousel = $manySlideCarousel.slick({
        speed: 1200,
        useCSS: true,
        useTransform: true,
        cssEase: 'cubic-bezier(0.190, 1.000, 0.220, 1.000)',
        prevArrow: $prevArrowEl,
        nextArrow: $nextArrowEl,
        responsive: [
          {
            breakpoint: 640,
            settings: {
              dots: true,
              arrows: false
            }
          }
        ]
      });
    }

    if ($automaticCarousel.length > 0) {
      // Homepage only carousel
      this.$carousel = $automaticCarousel.slick({
        speed         : 1200,
        useCSS        : true,
        useTransform  : true,
        autoplay      : true,
        autoplaySpeed : 3000,
        fade          : true,
        arrows        : false,
        pauseOnHover  : false,
        cssEase: 'cubic-bezier(0.190, 1.000, 0.220, 1.000)',
        responsive: [
          {
            breakpoint: 640,
            settings: {
              dots: true,
              arrows: false
            }
          }
        ]
      });
    }

    this.events();
  }

  events() {
    // var $gridBtn = $(this.$el).find('.site-carousel__grid-btn');
    // var $gridItem = $(this.$el).find('.site-carousel__grid-item');
    var $gridBtn = $(this.$el).find('.js-grid-btn');
    var $gridItem = $(this.$el).find('.js-grid-item');

    $gridBtn.on('click', (e) => {
      e.preventDefault();
      this.$el.toggleClass('open-grid');
    });

    $gridItem.on('click', (e) => {
      e.preventDefault();
      let pos = $(e.currentTarget).index();
      this.$el.removeClass('open-grid');
      this.$carousel.slick('slickGoTo', pos);
    });

  }
}

export {SiteCarousel as default};
